namespace GeniuzPOS.InitialData {
    export class PsSalesmanColumns {
        static columnsKey = 'InitialData.PsSalesman';
    }
}
